import {
  ApplicationConfig,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  LOCALE_ID,
  importProvidersFrom
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { provideToastr } from 'ngx-toastr';
import { OktaAuth } from '@okta/okta-auth-js';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';

import { routes } from './app.routes';
import { authInterceptor } from './interceptors/auth.interceptor';
import { authJwtInterceptor } from './interceptors/auth-jwt.interceptor';
import { installCopyBodyHtmlDebugShortcut } from './debug/planner-manager/copy-body-html.debug';
import { environment } from '../environments/environment';

registerLocaleData(localeEs);

const oktaProviders = environment.useSSO ? (() => {
  const oktaAuth = new OktaAuth({
    issuer: environment.okta.issuer,
    clientId: environment.okta.clientId,
    redirectUri: window.location.origin + '/callback',
    scopes: ['openid', 'alliance_profile', 'offline_access'],
    pkce: true,
    tokenManager: { storage: 'localStorage' }
  });
  const onAuthRequired = (auth: OktaAuth) => auth.signInWithRedirect({ originalUri: '/planner' });
  return [provideOktaAuth(withOktaConfig({ oktaAuth, onAuthRequired }))];
})() : [];

const plannerManagerDebugProviders = !environment.production
  ? [provideAppInitializer(() => { installCopyBodyHtmlDebugShortcut(); })]
  : [];

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(NgbModalModule),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimationsAsync(),
    provideToastr({
      positionClass: 'toast-top-right',
      timeOut: 4000,
      progressBar: true,
      closeButton: true,
    }),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptors([environment.useSSO ? authInterceptor : authJwtInterceptor])),
    ...oktaProviders,
    ...plannerManagerDebugProviders,
    { provide: LOCALE_ID, useValue: 'es' }
  ]
};
